// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || "http://localhost:3001/api",
  TIMEOUT: 10000,
} as const;

// App Configuration
export const APP_CONFIG = {
  NAME: "DDC Admin Dashboard",
  VERSION: "0.1.0",
} as const;

// Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: "auth_token",
  USER_DATA: "user_data",
  THEME: "theme",
} as const;

// Routes
export const ROUTES = {
  HOME: "/",
  DASHBOARD: "/admin/dashboard",
  DDCS: "/admin/ddcs",
  USERS: "/admin/users",
} as const;

// DDC Status
export const DDC_STATUS = {
  NORMAL: "normal",
  LOST: "lost",
  STOLEN: "stolen",
  DAMAGED: "damaged",
} as const;

// User Roles
export const USER_ROLES = {
  DEFAULT_ADMIN_ROLE: "DEFAULT_ADMIN_ROLE",
  MINTER_ROLE: "MINTER_ROLE",
  DATA_APPEND_ROLE: "DATA_APPEND_ROLE",
  UPGRADER_ROLE: "UPGRADER_ROLE",
} as const;
